module.exports = __webpack_public_path__ + "img/sld_battery_1_dark.aa94eef0.svg";